<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="mx-6 mb-6 mt-8 flex h-2 flex-grow flex-col">
    <div class="flex h-11 flex-row items-center justify-start">
      <div
        data-cy="projectEnvironmentsTitle"
        class="text-s1 flex select-none text-2xl font-semibold"
        >{{ pageTitle }}
      </div>

      <div
        class="ml-10"
        tp="Admin role required"
        [tpIsEnabled]="isAdmin === false"
      >
        <button
          data-cy="projectEnvironmentsAddEnvironmentButton"
          class="text-m0 h-11 flex-shrink-0 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
          type="submit"
          [ngClass]="{
            'bg-m600': isAdmin === true,
            'bg-s400 cursor-default': isAdmin === false
          }"
          (click)="addEnvironment()"
          [disabled]="isAdmin === false"
          >Add Environment</button
        >
      </div>
    </div>

    <div class="bg-m0 mt-6 flex-grow overflow-auto rounded shadow">
      <ng-scrollbar
        [orientation]="'auto'"
        [visibility]="'hover'"
        [appearance]="'compact'"
      >
        <div class="text-s1 mx-5 mt-8">
          <table class="divide-s500 min-w-full divide-y">
            <thead>
              <tr class="h-12 text-sm">
                <th class="select-none text-left"></th>
                <th class="select-none text-left">Environment Name</th>
                <th class="select-none text-left">Users</th>
                <th class="select-none text-left">Connections</th>
                <th class="select-none text-center">
                  <div class="flex flex-col">
                    <div>Connections Fallback</div>
                    <div>to Env Prod</div>
                  </div>
                </th>

                <th class="select-none text-center">
                  <div class="flex flex-col">
                    <div>Use Prod Cache</div>
                  </div>
                </th>

                <!-- <th class="select-none text-center">
                  <div class="flex flex-col">
                    <div>Variables Fallback</div>
                    <div>to Env Prod</div>
                  </div>
                </th> -->

                <!-- <th class="select-none pl-[60px] text-left">
                  <div class="mb-2 flex flex-row items-center">
                    <div>Environment Variables</div>

                    <div class="ml-5 flex">
                      <button
                        data-cy="projectInfoShowValueButton"
                        class="w-[140px] rounded border py-2 text-base font-normal leading-3 shadow-sm focus:outline-none"
                        [ngClass]="{
                          'border-s400 text-s500 hover:bg-s100':
                            isAdmin === true,
                          'border-s300 text-s400 cursor-default':
                            isAdmin === false
                        }"
                        (click)="toggleShowValues()"
                        [disabled]="isAdmin === false"
                        >{{ isShowValues ? 'Hide values' : 'Show values' }}
                      </button>
                    </div>
                  </div>
                </th> -->
                <th class="select-none"></th>
              </tr>
            </thead>

            <tbody class="divide-s300 divide-y text-base">
              <tr *ngIf="environments?.length === 0"> </tr>

              <tr *ngFor="let environment of environments" class="h-16">
                <td class="w-[100px]">
                  <ng-template #templateDeleteEnv>
                    <div *ngIf="environment.envId === envProd"
                      >Env Prod cannot be deleted</div
                    >

                    <div
                      *ngIf="environment.envId !== envProd && isAdmin === false"
                      >Admin role required</div
                    >
                  </ng-template>

                  <div
                    class="w-fit"
                    [tp]="templateDeleteEnv"
                    [tpIsEnabled]="
                      isAdmin === false || environment.envId === envProd
                    "
                  >
                    <button
                      data-cy="projectEnvironmentsDeleteButton"
                      class="ml-5 h-9 w-9 rounded focus:outline-none"
                      [ngClass]="{
                        'text-s1 hover:bg-m200':
                          isAdmin === true && environment.envId !== envProd,
                        'text-s400 cursor-default':
                          isAdmin === false || environment.envId === envProd
                      }"
                      [disabled]="
                        isAdmin === false || environment.envId === envProd
                      "
                      (click)="deleteEnvironment(environment)"
                    >
                      <div class="flex justify-center">
                        <m-trash-icon></m-trash-icon>
                      </div>
                    </button>
                  </div>
                </td>

                <td class="w-[200px]">{{ environment.envId }}</td>

                <td class="w-96">
                  <div class="my-3 flex flex-col">
                    <div *ngIf="environment.envId === envProd">
                      <div class="flex flex-row items-center text-base">
                        <div>All Users </div>
                      </div>
                    </div>

                    <div
                      *ngIf="environment.envId !== envProd"
                      class="flex flex-row items-center"
                    >
                      <div class="flex flex-row items-center">
                        <div
                          tp="Admin role required"
                          [tpIsEnabled]="isAdmin === false"
                        >
                          <button
                            data-cy="projectEnvironmentsAddVarButton"
                            class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                            [ngClass]="{
                              'text-s400 cursor-default': isAdmin === false,
                              'text-m600 hover:bg-m200': isAdmin === true
                            }"
                            (click)="addUser(environment)"
                            [disabled]="isAdmin === false"
                          >
                            <div>
                              <m-add-icon></m-add-icon>
                            </div>
                          </button>
                        </div>

                        <div class="ml-5 flex flex-col">
                          <div *ngFor="let envUser of environment.envUsers">
                            <div class="flex flex-row items-center text-base">
                              <div>{{ envUser.alias }} </div>

                              <div
                                tp="Admin role required"
                                class="ml-3"
                                [tpIsEnabled]="isAdmin === false"
                              >
                                <button
                                  data-cy="projectEnvironmentsRemoveUserButton"
                                  class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                                  [ngClass]="{
                                    'text-s400 cursor-default':
                                      isAdmin === false,
                                    'text-s1 hover:bg-m200': isAdmin === true
                                  }"
                                  (click)="removeUser(environment, envUser)"
                                  [disabled]="isAdmin === false"
                                >
                                  <div>
                                    <m-delete-icon></m-delete-icon>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="w-80">
                  <div class="my-3 flex flex-col">
                    <div
                      *ngFor="
                        let connectionId of environment.envConnectionIdsWithFallback
                      "
                    >
                      <div class="flex flex-row items-center text-base">
                        <div
                          tp="The connection is set because the fallback is enabled. You can override the connection by adding a connection with the same name."
                          [tpIsEnabled]="
                            environment.fallbackConnectionIds.indexOf(
                              connectionId
                            ) > -1
                          "
                          [ngClass]="{
                            'text-s400':
                              environment.fallbackConnectionIds.indexOf(
                                connectionId
                              ) > -1
                          }"
                          >{{ connectionId }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="w-[180px]">
                  <div class="flex justify-center">
                    <div tp="This env is prod">
                      <div *ngIf="environment.envId === envProd">—</div>
                    </div>
                    <div
                      *ngIf="environment.envId !== envProd"
                      tp="Admin role required"
                      [tpIsEnabled]="isAdmin === false"
                    >
                      <button
                        data-cy="projectTeamIsFallbackToProdConnectionsButton"
                        class="text-m0 flex h-5 w-5 items-center justify-center rounded border-2 focus:outline-none"
                        [ngClass]="{
                          'bg-m600':
                            environment.isFallbackToProdConnections === true &&
                            isAdmin === true,
                          'bg-s400 cursor-default':
                            environment.isFallbackToProdConnections === true &&
                            isAdmin === false,
                          'border-m600': isAdmin === true,
                          'border-s400 cursor-default': isAdmin === false
                        }"
                        (click)="isFallbackConnectionsChange(environment)"
                        [disabled]="isAdmin === false"
                      >
                        <m-check-icon
                          *ngIf="environment.isFallbackToProdConnections"
                        ></m-check-icon>
                      </button>
                    </div>
                  </div>
                </td>

                <td class="w-[140px]">
                  <div class="flex justify-center">
                    <div tp="This env is prod">
                      <div *ngIf="environment.envId === envProd">—</div>
                    </div>
                    <div
                      *ngIf="environment.envId !== envProd"
                      tp="Admin role required"
                      [tpIsEnabled]="isAdmin === false"
                    >
                      <button
                        class="text-m0 flex h-5 w-5 items-center justify-center rounded border-2 focus:outline-none"
                        [ngClass]="{
                          'bg-m600':
                            environment.useProdCache === true &&
                            isAdmin === true,
                          'bg-s400 cursor-default':
                            environment.useProdCache === true &&
                            isAdmin === false,
                          'border-m600': isAdmin === true,
                          'border-s400 cursor-default': isAdmin === false
                        }"
                        (click)="useProdCacheChange(environment)"
                        [disabled]="isAdmin === false"
                      >
                        <m-check-icon
                          *ngIf="environment.useProdCache"
                        ></m-check-icon>
                      </button>
                    </div>
                  </div>
                </td>

                <!-- <td class="w-[180px]">
                  <div class="flex justify-center">
                    <div tp="This env is prod">
                      <div *ngIf="environment.envId === envProd">—</div>
                    </div>
                    <div
                      *ngIf="environment.envId !== envProd"
                      tp="Admin role required"
                      [tpIsEnabled]="isAdmin === false"
                    >
                      <button
                        data-cy="projectTeamFallbackToProdVariablesButton"
                        class="text-m0 flex h-5 w-5 items-center justify-center rounded border-2 focus:outline-none"
                        [ngClass]="{
                          'bg-m600':
                            environment.isFallbackToProdVariables === true &&
                            isAdmin === true,
                          'bg-s400 cursor-default':
                            environment.isFallbackToProdVariables === true &&
                            isAdmin === false,
                          'border-m600': isAdmin === true,
                          'border-s400 cursor-default': isAdmin === false
                        }"
                        (click)="isFallbackEnvVarsChange(environment)"
                        [disabled]="isAdmin === false"
                      >
                        <m-check-icon
                          *ngIf="environment.isFallbackToProdVariables"
                        ></m-check-icon>
                      </button>
                    </div>
                  </div>
                </td> -->

                <!-- <td>
                  <div class="my-3 flex flex-col">
                    <div class="flex flex-row items-center pl-[60px]">
                      <div
                        tp="Admin role required"
                        [tpIsEnabled]="isAdmin === false"
                      >
                        <button
                          data-cy="projectEnvironmentsAddVarButton"
                          class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                          [ngClass]="{
                            'text-s400 cursor-default': isAdmin === false,
                            'text-m600 hover:bg-m200': isAdmin === true
                          }"
                          (click)="addVar(environment)"
                          [disabled]="isAdmin === false"
                        >
                          <div>
                            <m-add-icon></m-add-icon>
                          </div>
                        </button>
                      </div>

                      <div class="group ml-5 flex flex-row">
                        <div class="flex flex-col">
                          <div *ngFor="let ev of environment.evsWithFallback">
                            <div
                              class="flex h-8 flex-row items-center text-base"
                            >
                              <div
                                tp="The variable is set because the fallback is enabled. You can override the value by adding a variable with the same name."
                                [tpIsEnabled]="
                                  environment.fallbackEvIds.indexOf(ev.evId) >
                                  -1
                                "
                                [ngClass]="{
                                  'text-s400':
                                    environment.fallbackEvIds.indexOf(ev.evId) >
                                    -1
                                }"
                                >{{ ev.evId }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          *ngIf="isShowValues === true"
                          class="flex flex-col"
                        >
                          <div *ngFor="let ev of environment.evsWithFallback">
                            <div
                              class="flex h-8 flex-row items-center text-base"
                            >
                              <div
                                tp="value is an empty string"
                                [tpIsEnabled]="ev.val.length === 0"
                                class="bg-s200 ml-5 h-6 rounded px-2"
                                >{{ ev.val }}
                              </div>

                              <div
                                *ngIf="
                                  environment.fallbackEvIds.indexOf(ev.evId) < 0
                                "
                                tp="Admin role required"
                                [tpIsEnabled]="isAdmin === false"
                                class="ml-5"
                              >
                                <button
                                  data-cy="projectEnvironmentsEditVarButton"
                                  class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none group-hover:visible"
                                  [ngClass]="{
                                    'text-s400 cursor-default':
                                      isAdmin === false,
                                    'text-s1 hover:bg-m200': isAdmin === true
                                  }"
                                  (click)="editVar(environment, ev)"
                                  [disabled]="isAdmin === false"
                                >
                                  <div>
                                    <m-edit-icon></m-edit-icon>
                                  </div>
                                </button>
                              </div>

                              <div
                                *ngIf="
                                  environment.fallbackEvIds.indexOf(ev.evId) < 0
                                "
                                tp="Admin role required"
                                [tpIsEnabled]="isAdmin === false"
                                class="ml-2"
                              >
                                <button
                                  data-cy="projectEnvironmentsRemoveVarButton"
                                  class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none group-hover:visible"
                                  [ngClass]="{
                                    'text-s400 cursor-default':
                                      isAdmin === false,
                                    'text-s1 hover:bg-m200': isAdmin === true
                                  }"
                                  (click)="removeVar(environment, ev)"
                                  [disabled]="isAdmin === false"
                                >
                                  <div>
                                    <m-delete-icon></m-delete-icon>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </ng-scrollbar>
    </div>
  </div>
</div>

<div *ngIf="nav$ | async"></div>
<div *ngIf="isAdmin$ | async"></div>
<div *ngIf="isEditor$ | async"></div>
<div *ngIf="environments$ | async"></div>
